import Icon from 'components/shared/icon';
import { useEffect, useState } from 'react';
import RichText from 'components/shared/richtext';
import { useRouter } from 'next/router';
import { useGlobalModules } from 'contexts';
import styles from './kickbackfeePopup.module.scss';

const KickbackfeePopup = () => {
  const globalModules = useGlobalModules();
  const { translations, links } = globalModules || {};
  const shopNowLink = links?.link?.shopNow;

  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [salonName, setSalonName] = useState('');

  useEffect(() => {
    if (!router.isReady) return;

    const kickbackFeeSalonName = router.query.fromKickbackFeeCode;

    if (kickbackFeeSalonName) {
      setOpen(true);
      setSalonName(kickbackFeeSalonName);
      document.body.style.overflow = 'hidden';
    }
  }, [router.query, router.isReady]);

  const handleClose = () => {
    document.body.style.overflow = '';
    const { pathname, query } = router;
    delete router.query.fromKickbackFeeCode;
    router.replace({ pathname, query }, undefined, { shallow: true });
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={() => {
            handleClose();
          }}
        >
          <Icon type="close" />
        </button>
        <div className={styles.title}>
          {translations?.kickbackfeePopup?.title}
          <span>{salonName}</span>
        </div>
        <RichText text={translations?.kickbackfeePopup?.message?.json} className={styles.message} />

        <button type="button" className={styles.button} onClick={handleClose}>
          {shopNowLink?.title}
        </button>
      </div>
    </div>
  );
};

export default KickbackfeePopup;
